module.exports = "<app-list-display [title]=\"'Projects'\" [component_id]=\"'projects'\" [items]=\"projects\"></app-list-display>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/spina-me/source/src/app/projects/projects.component.html
// module id = ../../../../../src/app/projects/projects.component.html
// module chunks = 1